import axios from 'axios';
import { ADMIN_API_BASE, adminAuthConfig } from './api_admin';

const _err = (e) => { if (e.response) console.error('Admin profiles error:', e.response.status, e.response.data); };
const qs = (p) => {
    const s = new URLSearchParams();
    Object.entries(p || {}).forEach(([k, v]) => { if (v !== undefined && v !== null && v !== '') s.append(k, v); });
    return s.toString();
};

export const APIAdminProfiles = async (token, params = {}) => {
    try { const r = await axios.get(`${ADMIN_API_BASE}/profiles/?${qs(params)}`, adminAuthConfig(token)); return r.data; }
    catch (e) { _err(e); throw e; }
};
export const APIAdminProfileDetail = async (token, id) => {
    try { const r = await axios.get(`${ADMIN_API_BASE}/profiles/${id}/`, adminAuthConfig(token)); return r.data; }
    catch (e) { _err(e); throw e; }
};
export const APIAdminProfileUpdate = async (token, id, data) => {
    try { const r = await axios.patch(`${ADMIN_API_BASE}/profiles/${id}/update/`, data, adminAuthConfig(token)); return r.data; }
    catch (e) { _err(e); throw e; }
};
export const APIAdminProfileAccept = async (token, id) => {
    try { const r = await axios.post(`${ADMIN_API_BASE}/profiles/${id}/accept/`, {}, adminAuthConfig(token)); return r.data; }
    catch (e) { _err(e); throw e; }
};
export const APIAdminProfileBlock = async (token, id, reason) => {
    try { const r = await axios.post(`${ADMIN_API_BASE}/profiles/${id}/block/`, { reason }, adminAuthConfig(token)); return r.data; }
    catch (e) { _err(e); throw e; }
};